export function isDashboardActive(pathname: string): boolean {
  return pathname === "/dashboard";
}

export function isCrmActive(pathname: string): boolean {
  return pathname === "/crm" || pathname.startsWith("/crm/");
}

export function isManualsActive(pathname: string): boolean {
  return pathname.startsWith("/manuals");
}

export function isContactsActive(pathname: string): boolean {
  return pathname.startsWith("/contacts");
}

export function isImagesActive(pathname: string): boolean {
  return pathname.startsWith("/images");
}

export function isShoppingListActive(pathname: string): boolean {
  return pathname === "/shopping-list";
}

export function isSettingsActive(pathname: string): boolean {
  return pathname.startsWith("/settings");
}
